// extracted by mini-css-extract-plugin
export default {"container":"InfoWithIconAndNavigation_container__-bxn6","icon":"InfoWithIconAndNavigation_icon__aC9zl"};